import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative bg-background-50">
      <div className="flex flex-col lg:flex-row min-h-[480px]">
        <div className="lg:w-1/2 relative min-h-[320px] lg:min-h-[480px]">
          <img
            src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20elegant%20product%20display%20with%20fashion%20items%20on%20warm%20cream%20background%2C%20stylish%20flat%20lay%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20professional%20aesthetic%2C%20shoes%20and%20bags%20and%20accessories%2C%20harmonious%20warm%20composition&width=1000&height=700&seq=cta-left-v3&orientation=portrait"
            alt="AcBuy products"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
          <div className="absolute top-6 left-6">
            <span className="text-xs font-medium text-background-50/80 tracking-wider">Trusted by 10,000+ Users</span>
          </div>
          <div className="absolute bottom-8 left-6 right-6">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-background-50 leading-tight">
              Start Your<br />AcBuy<br />Journey Today
            </h2>
          </div>
        </div>

        <div className="lg:w-1/2 bg-background-50 flex items-center justify-center px-6 md:px-12 py-12 md:py-16">
          <div className="max-w-md text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight mb-4">
              Get AcBuy<br />Spreadsheet Now
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              Join thousands of smart shoppers who use the AcBuy Spreadsheet every day. Access verified product links, trusted sellers, and expert buying guides — all in one organized place. Stop searching manually and start shopping smarter.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-foreground-950 hover:bg-foreground-900 text-background-50 font-semibold px-8 py-3.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
              >
                Browse Categories
                <i className="ri-external-link-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}